import { render } from "./KotDetail.vue?vue&type=template&id=7581a9bc&scoped=true"
import script from "./KotDetail.vue?vue&type=script&lang=js"
export * from "./KotDetail.vue?vue&type=script&lang=js"

import "./KotDetail.vue?vue&type=style&index=0&id=7581a9bc&lang=css"
import "./KotDetail.vue?vue&type=style&index=1&id=7581a9bc&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7581a9bc"]])

export default __exports__